/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * ⚠️ **表示名は「合計ナンプレ」だが、キーに `nanpure` を含めない**（2026-09-12 に決定）。
 *   既存の [nanpure](../nanpure/gameKey.ts) と接頭辞が衝突すると、localStorage を
 *   **接頭辞で掃く**データ削除（`GAME_STORAGE_PREFIXES`）が巻き添えで消す。
 *   ⇒ 英語名の `Number Sum` を採って `numbersum`。
 */
export const GAME_KEY = 'numbersum';
